import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.SaveSimple.IRequest;
type Response = Api.Core.Claim.SaveSimple.IResponse;
type Headers = Api.Core.Claim.SaveSimple.IHeaders;
const url = '/api/Claims/Claim/simple';
export default async function claimSaveSimpleApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
